import React from 'react';

import clsx from 'clsx';

import TableHead from 'components/Table/TableHead/TableHead';
import TableHeadCell from 'components/Table/TableHeadCell/TableHeadCell';
import TableBody from 'components/Table/TableBody/TableBody';
import Table from 'components/Table/Table';
import TableRow from 'components/Table/TableRow/TableRow';
import TableBodyCell from 'components/Table/TableBodyCell/TableBodyCell';
import { Button } from 'components/Buttons/Button';
import { maskMonetaryValue } from 'prequalificationV2/utils/stringUtils';
import { OFFERS_SORTING_FIELD } from 'prequalificationV2/components/Offers/OffersTableWrapper/offersTableWrapper.constants';
import { OffersPageFilters } from 'prequalificationV2/components/Offers/OffersTableWrapper/offersTableWrapper.types';
import { OffersTableColumnsTitle } from 'prequalificationV2/components/Offers/OffersTableWrapper/offersTableWrapper.enums';
import OfferRowLabel from 'prequalificationV2/components/Offers/OffersTableWrapper/OfferRowLabel/OfferRowLabel';
import { OfferDto } from 'api/OffersApi';

import styles from './OffersTableMobile.module.scss';

export interface OffersTableMobileProps {
  offers: OfferDto[];
  onAcceptOffer: (loanOffer: OfferDto) => void;
  isDisabled: boolean;
  filters: OffersPageFilters;
  updateTableSort: (sortField?: keyof OfferDto) => void;
}

const OffersTableMobile = ({ onAcceptOffer, isDisabled, filters, updateTableSort, offers }: OffersTableMobileProps) => {
  return (
    <Table className={styles.table}>
      <TableHead className={styles.tableHead}>
        <TableHeadCell
          key={OffersTableColumnsTitle.Term}
          className={clsx(styles.tableHeadCell, {
            [styles.tableHeadCellSorted]: filters.sortField === OFFERS_SORTING_FIELD[OffersTableColumnsTitle.Term],
          })}
          isExist={true}
          isSorted={!!OFFERS_SORTING_FIELD[OffersTableColumnsTitle.Term]}
          currentSort={filters.sortField === OFFERS_SORTING_FIELD[OffersTableColumnsTitle.Term]}
          isSortedDesc={filters.isSortDesc}
          onClick={() => updateTableSort(OFFERS_SORTING_FIELD[OffersTableColumnsTitle.Term])}
        >
          Sort by: {OffersTableColumnsTitle.Term}
        </TableHeadCell>
      </TableHead>
      <TableBody>
        {offers.map((offer: OfferDto, index) => (
          <TableRow key={index} className={clsx(styles.tableRowTemplate, styles.tableRow)}>
            <TableBodyCell>
              <div className={styles.tableBodyCell}>
                <span>Term</span>
                <span>{offer.term} years</span>
              </div>
            </TableBodyCell>
            <TableBodyCell>
              <div className={styles.tableBodyCell}>
                <span>Fixed Rate</span>
                <span>{offer.rate}%</span>
              </div>
            </TableBodyCell>
            <TableBodyCell>
              <div className={styles.tableBodyCell}>
                <span>APR</span>
                <span>{offer.apr}%</span>
              </div>
            </TableBodyCell>
            <TableBodyCell>
              <div className={styles.tableBodyCell}>
                <span>Monthly Payments</span>
                <span>{maskMonetaryValue(offer.monthlyPayment?.toFixed(2))}</span>
              </div>
            </TableBodyCell>
            <TableBodyCell>
              <Button className={styles.acceptButton} disabled={isDisabled} onClick={() => onAcceptOffer(offer)}>
                Accept
              </Button>
            </TableBodyCell>
            <OfferRowLabel offer={offer} />
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default OffersTableMobile;
